import React,{useState} from 'react'
import Button from 'react-bootstrap/Button'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import styles from './EllipsisMenu.module.css'

const EllipsisMenu = ({children,className,tip})=>{
	const [open,setOpen] = useState(false)
	return (
		<div className={[styles.EllipsisMenu,className].join(' ')}>
			<div className={[styles.Options,open&&styles.Show].join(' ')}>
				{children}
				<OverlayTrigger overlay={
					<Tooltip>{'Click to close options'}</Tooltip>
				}>
					<Button onClick={()=>{setOpen(false)}} variant="outline-danger" size="sm">
						<i className="fas fa-ellipsis-h"/>
					</Button>
				</OverlayTrigger>
			</div>
			<OverlayTrigger overlay={
				<Tooltip>{tip||'Click for more options'}</Tooltip>
			}>
				<button 
					style={{
						width:'24px',
						height:'24px',
						borderRadius:'5px',
						background:'#fff',
						border:'1px solid #777',
						color:'#777',
						fontSize:'10px'
					}}
					onClick={()=>{setOpen(true)}} 
					variant="outline-secondary" 
					size="sm"
				>
					<i className="fas fa-ellipsis-h"/>
				</button>
			</OverlayTrigger>
		</div>
	)
}

export default EllipsisMenu